module.exports = __webpack_public_path__ + "static/atlanta_skyline-72623bb71426bd6c960288253798afdd.png";